<template>
  <div class="settings-page">
    <v-container :fluid="true">
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="tableHeaders"
            :items="tableItems"
            :items-per-page="6"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Installment Tenure Settings</v-toolbar-title>
                <v-spacer />
                <v-btn depressed color="primary" @click="createItem">
                  Add Item
                  <v-icon right color="white"> mdi-flask-empty-plus </v-icon>
                </v-btn>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="createItemModel" persistent max-width="650">
      <v-card>
        <ValidationObserver
          ref="observer"
          autocomplete="off"
          tag="form"
          @submit.prevent="addNewItem"
        >
          <v-card-title class="custom-modal-title">
            Add Tenure Item
          </v-card-title>
          <v-divider class="divider-title" />
          <v-card-text>
            <ValidationProvider
              v-slot="{ errors }"
              name="tenureTime"
              rules="required"
              class="input-wrapper required-field"
            >
              <v-text-field
                v-model="newItem.tenureTime"
                name="tenureTime"
                type="number"
                label="Tenure"
                filled
                dense
              />
              <span class="error-message">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              name="interestRate"
              rules="required"
              class="input-wrapper required-field"
            >
              <v-text-field
                v-model="newItem.interestRate"
                name="interestRate"
                type="number"
                label="Interest Rate"
                filled
                dense
                step="0.01"
              />
              <span class="error-message">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              name="interestAmount"
              rules="required"
              class="input-wrapper required-field"
            >
              <v-text-field
                v-model="newItem.interestAmount"
                name="interestAmount"
                type="number"
                label="Interest Amount"
                filled
                dense
              />
              <span class="error-message">{{ errors[0] }}</span>
            </ValidationProvider>
          </v-card-text>
          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn color="gray" text @click="createItemModel = false">
              cancel
            </v-btn>
            <v-btn color="primary" text type="post"> create </v-btn>
          </v-card-actions>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showEditModel" persistent max-width="650">
      <v-card>
        <ValidationObserver
          ref="observer"
          autocomplete="off"
          tag="form"
          @submit.prevent="updateItem"
        >
          <v-card-title class="custom-modal-title">
            Update Tenure Item
          </v-card-title>
          <v-divider class="divider-title" />
          <v-card-text>
            <ValidationProvider
              v-slot="{ errors }"
              name="tenureTime"
              rules="required"
              class="input-wrapper required-field"
            >
              <v-text-field
                v-model="selectedItem.tenureTime"
                name="tenureTime"
                type="number"
                label="Tenure"
                filled
                dense
              />
              <span class="error-message">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              name="interestRate"
              rules="required"
              class="input-wrapper required-field"
            >
              <v-text-field
                v-model="selectedItem.interestRate"
                name="interestRate"
                type="number"
                label="Interest Rate"
                filled
                dense
                step="0.01"
              />
              <span class="error-message">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              name="interestAmount"
              rules="required"
              class="input-wrapper required-field"
            >
              <v-text-field
                v-model="selectedItem.interestAmount"
                name="interestAmount"
                type="number"
                label="Interest Amount"
                filled
                dense
              />
              <span class="error-message">{{ errors[0] }}</span>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              name="interestWavier"
              class="input-wrapper"
            >
              <v-text-field
                v-model="selectedItem.interestWavier"
                name="interestWavier"
                type="number"
                label="Interest Wavier"
                step="0.01"
                filled
                dense
              />
              <span class="error-message">{{ errors[0] }}</span>
            </ValidationProvider>
          </v-card-text>
          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn color="gray" text @click="showEditModel = false">
              cancel
            </v-btn>
            <v-btn color="primary" text type="post"> update </v-btn>
          </v-card-actions>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showConfirmModel" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          Are you sure you want to delete?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn color="darken-1" text @click="showConfirmModel = false">
            cancel
          </v-btn>
          <v-btn color="primary darken-1" text @click="confirmDelete">
            continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Promise from '../../../../lib/mixins/ExtendedPromises';
import Insta from '../../../../repositories/instaSettings';
export default {
  name: 'Settings',
  mixins: [Promise],
  data() {
    return {
      selectedItem: '',
      createItemModel: false,
      showEditModel: false,
      tenureItem: [],
      tableHeaders: [],
      tableItems: [],
      showConfirmModel: false,
      newItem: {
        tenureTime: '',
        interestRate: '',
        interestAmount: '',
        interestWavier: 100,
      },
    };
  },
  created() {
    this.setTableHeader();
    this.getTenureItem();
  },
  mounted() {},
  methods: {
    setTableHeader() {
      this.tableHeaders = [
        {
          text: 'Tenure',
          align: 'start',
          sortable: false,
          value: 'tenureTime',
        },
        { text: 'Interest Rate', value: 'interestRate' },
        { text: 'Interest Amount', value: 'interestAmount' },
        { text: 'Interest Wavier', value: 'interestWavier' },
        { text: 'Actions', value: 'actions', sortable: false },
      ];
    },
    getTenureItem() {
      const compare = (a, b) => {
        const bandA = a.tenureTime;
        const bandB = b.tenureTime;
        let comparison = 0;
        if (a > b) {
          comparison = 1;
        } else if (bandA < bandB) {
          comparison = -1;
        }
        return comparison;
      };
      const operation = this.response(Insta.get());
      operation
        .then((data) => {
          if (operation.isFulfilled()) {
            const settings = [...data.Settings];
            settings.sort(compare);
            this.tableItems = settings;
          }
        })
        .catch((err) => {
          if (operation.isRejected()) {
            this.$toasted.show('could not get insta rates');
          }
        });
    },
    createItem() {
      this.createItemModel = true;
    },
    addNewItem() {
      const operation = this.response(Insta.create(this.newItem));
      operation
        .then((data) => {
          if (operation.isFulfilled()) {
            this.getTenureItem();
            this.$toasted.show('Created', {
              type: 'success',
            });
            this.createItemModel = false;
            this.newItem = {
              tenureTime: '',
              interestRate: '',
              interestAmount: '',
              interestWavier: 100,
            };
          }
        })
        .catch((err) => {
          if (operation.isRejected()) {
            this.createItemModel = false;
            this.$toasted.show('could not add new item');
            this.newItem = {
              tenureTime: '',
              interestRate: '',
              interestAmount: '',
              interestWavier: 100,
            };
          }
        });
    },
    deleteItem(item) {
      this.selectedItem = item;
      this.showConfirmModel = true;
    },
    confirmDelete() {
      const ID = this.selectedItem.id;
      const operation = this.response(Insta.deleteItem(ID));
      operation
        .then((data) => {
          if (operation.isFulfilled()) {
            this.getTenureItem();
            this.$toasted.show('Deleted', {
              type: 'success',
            });
            this.showConfirmModel = false;
            this.selectedItem = '';
          }
        })
        .catch((err) => {
          if (operation.isRejected()) {
            this.showConfirmModel = false;
            this.selectedItem = '';
            this.$toasted.show('could not delete item');
          }
        });
    },
    editItem(item) {
      this.selectedItem = item;
      this.showEditModel = true;
    },
    updateItem() {
      const ID = this.selectedItem.id;
      const {
        interestAmount,
        interestRate,
        tenureTime,
        interestWavier,
      } = this.selectedItem;
      const updatedItem = {
        interestAmount,
        interestRate,
        tenureTime,
        interestWavier,
      };
      const operation = this.response(Insta.updateItem(updatedItem, ID));
      operation
        .then((data) => {
          if (operation.isFulfilled()) {
            this.$toasted.show('Updated', {
              type: 'success',
            });
            this.showEditModel = false;
            this.selectedItem = '';
          }
        })
        .catch((err) => {
          if (operation.isRejected()) {
            this.showEditModel = false;
            this.selectedItem = '';
            this.$toasted.show('could not update item');
          }
        });
    },
  },
};
</script>
